import axios from 'axios'
import { devLog } from './devLog'
import { API_URL, ONBOARDING_SERVICE_PATH } from '@constants/apiUrl'

interface actionReportPayload {
  type: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any
}

export async function actionReport(event: actionReportPayload) {
  try {
    await axios.post(`${API_URL}/${ONBOARDING_SERVICE_PATH}/audit-log-gateway`, event, {
      withCredentials: true,
    })
  } catch (e) {
    devLog(e)
  }
}
